<template>
<div class="switchsupport_form ">
    <h2>{{type_name}} Kündigungsbrief</h2>
    <div class="form-group">
        <label>Bisheriger Anbieter</label>
        <select v-model="provider_id">
            <option v-for="p in providers" :value="p.id">{{p.title}}</option>
        </select>
    </div>
    <div class="form-group" v-if="1 < senders.length">
        <label>Absender-Adresse</label>
        <div class="checkbox_group">
        <label v-for="s in senders">
            <input type="radio" v-model="sender" :value="s.value" :disabled="isDisabled(s)"> {{s.text}}
        </label>
        </div>
    </div>
    
    
    <div class="form-group">
        <label>Kündigungsdatum</label>
        <div class="checkbox_group">
            <label v-for="d in date_choices">
                <input type="radio" v-model="date_selection" :value="d.value" />{{d.text}}
            </label>
        </div>
    </div>
    <div class="form-group">
        <div class="datepicker_container">
        <DatePicker 
                    v-if="'own' == date_selection"
                    format="dd.MM.yyyy"
                    v-model="own_date"
                    input-class="form-control"
                    placeholder="Datum eingeben"
                    :monday-first="true"
                    :language="datepicker_lang"></DatePicker>
            </div>
    </div>

    <div class="form-group">
        <label>Kundennummer</label>
        <input v-model="customer_number" type="text" />
    </div>

    <div class="form-group">
        <label v-if="'phone' == this.type">Telefonnummer</label>
        <label v-else>Vertragsnummer</label>
        <input v-model="contract_number" type="text" />
    </div>

    <div id="kuendigung_content">
        
        <div class="letter_from">
            <textarea id="letter_from" rows="4" placeholder="Absenderadresse" v-model="sender_address"></textarea>
        </div>
        <div class="letter_to">
            Einschreiben<br/>
            <textarea rows="4" placeholder="Provider-Adresse" v-model="provider_address"></textarea>
        </div>

        <p class="letter_date">Datum: {{ new Date() | moment("DD.MM.YYYY")}}</p>

        <p class="letter_subject"><b>{{subject}}</b></p>

        <div class="letter_content">
            <p>Sehr geehrte Damen und Herren</p>
            <p>Hiermit kündige ich verbindlich und fristgerecht meinen {{type_name}}
                <template v-if="'contract'==date_selection">per sofort zum nächstmöglichen Termin.</template>
                <template v-else-if="'own'==date_selection && own_date">per <b>{{own_date|moment('DD.MM.YYYY')}}</b>.</template>
                <template v-else>per sofort.</template>
            </p>

            <p v-if="customer_number">Meine Kundennummer: <b>{{customer_number}}</b></p>
            <p v-if="contract_number">
                <span v-if="'phone'==type">Telefonnumer:</span>
                <span v-else>Vertragsnummer:</span>
                <span><b>{{contract_number}}</b></span></p>


            <p>Bitte bestätigen Sie mir den Erhalt dieser Kündigung schriftlich sowie das Datum, 
                an welchem der Dienst deaktiviert wird.</p>

            <p><br/><br/><br/>Freundliche Grüsse</p>
        </div>
        <p><input id="gruss_name" placeholder="Vorname Nachname" v-model="gruss_name"  /></p>
    </div>
    <button class="btn_print" type="button" @click="print">PDF erstellen</button>
</div>
</template>

<script>
import jsPDF from 'jspdf';
import AddressService from '@/services/AddressService.js';
//https://github.com/charliekassel/vuejs-datepicker
import DatePicker from 'vuejs-datepicker';
import {en,de} from 'vuejs-datepicker/dist/locale'
var moment = require('moment');
export default {
    props: ['type'],
    name: 'CancelDefault',
    components: { DatePicker },
    data: function(){
        return {
            gruss_name: '',
            customer_number: '',
            contract_number: '',
            provider_id: 0,
            provider_address: '',
            sender: 'own',
            sender_address: '',
            date_choices: [
                {value: 'contract', text: 'Nächstmöglicher Termin'},
                {value: 'own', text: 'Datum selbst wählen'},
            ],
            date_selection: 'contract', 
            own_date: null, 
        };
    },
    computed:{
        datepicker_lang: function(){
          return de;
        },
        type_name: function(){
            if ('internet' == this.type){
                return 'Internetanschluss';
            } else if ('phone' == this.type) {
                return 'Telefonanschluss';
            } else if ('cable' == this.type){
                return 'Kabelanschluss';
            }else if ('television' == this.type){
                return 'TV';
            } else {
                return '';
            }
        },
        subject: function(){
            return 'Kündigung '+this.type_name.toUpperCase();
        },
        order: function(){
            return this.$store.state.order;
        },
        providers: function(){
            return this.$store.state.providers;
        },
        senders: function(){
            let choices = [];
            choices.push({value:'own', text: 'Andere'});
            if (this.order && this.order['address_invoice']) {
                choices.push({value:'address_invoice', text: 'Rechnungsadresse'});
            }
            if (this.order && this.order['address_delivery']) {
                choices.push({value:'address_delivery', text: 'Lieferadresse Adresse'});
            }
            if (this.order && this.order['address_technical']) {
                choices.push({value:'address_technical', text: 'Technische Adresse'});
            }
            return choices;
        },
        
    },
    methods: {
        print: function(){
            let that = this;
            var doc = new jsPDF();
            doc.setFontSize(12);

            // Absender
            doc.text(that.sender_address, 25, 30);
            doc.setFontStyle('bold');
            doc.text('Einschreiben', 115, 60);
            doc.setFontStyle('normal');
            doc.text(that.provider_address, 115, 68);
            doc.text('Datum: '+moment().format('DD.MM.YYYY'), 25, 98);
            doc.setFontStyle('bold');
            doc.text(that.subject, 25, 115);
            let text = 'Sehr geehrte Damen und Herren'
            let letter_content = '<div style="font-family: sans-serif;font-size: 12pt;">'+
                document.querySelector('.letter_content').innerHTML+
                '<p>'+that.gruss_name+'</p>'+
                '</div>';
            doc.fromHTML(letter_content, 25, 135, {width: 160});
            doc.save('kuendigung_'+that.type+'.pdf')
        },
        isDisabled: function(sender){
            if ('own' == sender.value){
                return false;
            }
            return !(this.order && this.order[sender.value]);
        },

        setSenderAddress: function(){
            let that = this;
            if ('own' != this.sender && that.order){
                that.sender_address = AddressService.buildTextarea(that.order[that.sender]);
            } else {
                that.sender_address = 'Vorname Nachname\nStrasse\nPLZ Ort';
            }
        },
        setProviderAddress: function(){
            let that = this;
            if (0 == this.provider_id){
                that.provider_address = 'Firma\nStrasse\nPLZ Ort';
            } else {
                let p = this.providers.filter(function(item){
                    return item.id == that.provider_id;
                })[0];
                if (p){
                    that.provider_address = p.title+'\n'+
                        p.street+' '+p.housenr+'\n'+
                        p.zip+' '+p.city;
                }
            }
        },
        loadProviders: function(){
            let that = this;
            that.$store.state.ApiService.sendRequest('GET', '/infos/provider/'+that.type, null, function(dat, err, stat){
                let providers = [{id:0,title:'Anderer'}];
                if (dat){
                    dat.sort(function(a,b){
                        return a.title.localeCompare(b.title);
                    })
                    providers.push(...dat);
                    that.$store.commit('providers', providers);
                }
            });
        }
    },
    watch: {
        provider_id: function(){
            this.setProviderAddress();
            
        },
        sender: function(){
            this.setSenderAddress();
        },
        type: function(){
            this.loadProviders();
        },
    },
    created: function(){
        this.setSenderAddress();
        this.setProviderAddress();
        this.loadProviders();
    },

}
</script>
